import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

const SolveProblemsStartup = props => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: false,
    autoplay: true,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerMode: true,
          centerPadding: '25px',
        },
      },
    ],
  };

  return (
    <>
      <style>
        {`
              .solve-problems .slick-track {
                display:flex;
                margin:0
              }
              .solve-problems .slick-slide {
                width:33%;
                margin-right:5px
              }
              .solve-problems .slick-slide {
                outline: none
              }
              .solve-problems .slick-slide div {
                 outline: none
              }
              .solve-problems .slick-slide:focus,.slick-slide a {
                outline: none;
              }
              .shadow-new {
                box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 7%);
                border-radius: 0px 0px 25px 25px;
              }
              .shadow-new-w {
                box-shadow: 0px 1px 6px 1px rgb(0 0 0 / 7%);
              }
              .custom-dots {
                display:flex!important;
                justify-content:center;
              }
              .custom-dots li {
                position:relative;
                margin:0 3px;
                margin-top:20px;
                width:50px;
                height:2px;
                background-color: #C4C4C4; 
                overflow:hidden;
              }
              .custom-dots li.slick-active {
                background-color:#670F7A;
              }
              .custom-dots li button {
                position:absolute;
                width:100%;
                height:100%;
                top:0;
                left:0;
                opacity:0;
              }
              .slick-list:first-of-type,for-hover:first-of-type {
                padding-left:0!important;
              }
        `}
      </style>

      <Slider ref={slider} {...settings} className="solve-problems relative z-10 pt-24  ">
        <div className={'w-30p block mr-10 pr-0 md:pr-15'}>
          <div className={'bg-gray-slideOne px-18 py-12  min-h-340 md:min-h-280'}>
            <h3 className={'font-bold text-24 leading-29 text-purple'}>Highlight your Unique Selling Proposition (USP)</h3>
            <div className={'pr-0 md:pr-30'}>
              <p className={'mt-10'}>
                Your startup probably has specific benefits. Share them with a startup explainer video. Show what makes your solution different. An
                engaging video can set you apart from competitors. All the uniqueness of your startup will reach your target audience.
              </p>
            </div>
          </div>
        </div>
        <div className={'w-30p mr-10 px-0 md:px-15'}>
          <div className={'bg-red-slideTwo px-18 py-12  min-h-340 md:min-h-280'}>
            <h3 className={'font-bold text-24 leading-29 text-purple'}>Trust Building Solution </h3>
            <div className={'mt-10'}>
              <p className={'mt-10'}>
                What can bring you customers? Of course, trust! Trust comes in several aspects. But there's one thing that can do everything at once -
                a startup explainer video. Improve the visibility and online presence of your startup explainer videos for businesses. Explanation of
                services will enhance understanding. That's how trust comes.
              </p>
            </div>
          </div>
        </div>
        <div className={'w-30p mr-10 pl-0 md:pl-15'}>
          <div className="bg-blue-slideTree px-18 py-12  min-h-340 md:min-h-280">
            <h3 className={'font-bold text-24 leading-29 text-purple'}>Brand Storytelling</h3>
            <p className={'mt-10'}>
              How to promote a startup? Startup already makes sense. Can you imagine what can happen when it starts to talk itself? Startup animation
              videos can be fantastic. Storytelling builds an emotional connection between your brand and customers. Sharing your journey and missions
              will reserve your spot in the competitive market.
            </p>
          </div>
        </div>
      </Slider>
    </>
  );
};
export default SolveProblemsStartup;
